<template>
  <div class="pic-dettaglio">

    <!-- HEADER PIANO-->
    <div class="detail-box">
      <div class="detail-title">
        Piano {{ piano.id }}
      </div>
      <div class="detail-name">
        {{ piano.nome }}
      </div>

      <!-- BADGE TIPO PIANO-->
     <span
      v-if="isPadre"
      class="type-chip padre"
    >
      PADRE
    </span>

    <span
      v-if="isFiglio"
      class="type-chip figlio"
    >
      FIGLIO
    </span>

    <div class="detail-dates">
      Data decorrenza:
      <strong>{{ piano.decorrenza }}</strong>
      -
      Data scadenza:
      <strong>{{ piano.scadenza }}</strong>
    </div>
    <div class="progress-header">
      <span>Percentuale di spesa</span>
      <span class="progress-value">
        {{ percentualeSpesaLabel }}%
      </span>
    </div>
    <b-progress
      :max="100"
      height="10px"
      class="mb-2"
    >
      <b-progress-bar
        :value="percentualeSpesa"
        class="progress-bar-navy"
      />
    </b-progress>

    <!-- BOTTONI PER NAVIGAZIONE PADRE / FIGLI -->
    <div
      v-if="isPadre || isFiglio"
      class="children-buttons"
    >
      <!-- torna al padre -->
      <b-button
       v-if="isFiglio"
        class="child-button"
         @click="$emit('select-child', piano.parent)"
      >
        {{ piano.parent.id }} - {{ piano.parent.nome }}

        <b-icon icon="caret-up-fill"/>
      </b-button>

      <!-- figli -->
      <b-button
        v-for="child in visibleChildren"
        :key="child.id"
        class="child-button"
        @click="toggleChild(child,$event)"
      >
        {{ child.id }} - {{ child.nome }}

        <b-icon
          :icon="
            selectedChildId === child.id
              ? 'caret-up-fill'
              : 'caret-down-fill'
          "
        />
      </b-button>
    </div>
  </div>

    <!-- KPI -->
    <div class="kpi-grid">
      <b-row class="kpi-row mt-1">
        <b-col
          cols="12"
          md="3"
          class="kpi-col"
        >
          <b-card class="kpi-card kpi-caricato text-center">
            <div class="kpi-label">
              Totale Caricato
            </div>
            <div class="kpi-value">
              {{ formatEuro(piano.caricato) }}
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="kpi-col"
        >
          <b-card class="kpi-card kpi-speso text-center">
            <div class="kpi-label">
              Totale Speso
            </div>
            <div class="kpi-value">
              {{ formatEuro(piano.speso) }}
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="kpi-col"
        >
          <b-card class="kpi-card kpi-residuo text-center">
            <div class="kpi-label">
              Residuo
            </div>
            <div class="kpi-value">
              {{ formatEuro(piano.residuo) }}
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="kpi-col"
        >
          <b-card class="kpi-card kpi-dipendenti text-center">
            <div class="kpi-label">
              Dipendenti
            </div>
            <div class="kpi-value">
              {{ piano.dipendenti || 0 }}
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <!-- METRICHE PIC -->
    <PICMetriche
      :metriche="metriche"
      :expanded="expanded"
    />
    <!-- DISTRIBUZIONE SPESE -->
    <PICDistribuzione
      :distribuzione="distribuzione"
    />
    <!-- DETTAGLIO DIPENDENTI -->
    <PICDipendenti
      :dipendenti="dipendenti"
    />
  </div>
</template>

<script>
import PICMetriche from "./PICMetriche.vue";
import PICDistribuzione from "./PICDistribuzione.vue";
import PICDipendenti from "./PICDipendenti.vue";

export default {
  name: "PICDettaglio",

  components: {
    PICMetriche,
    PICDistribuzione,
    PICDipendenti
  },

  props: {
    expanded: {
      type:Boolean,
      default:false
    },

    piano: {
      type: Object,
      required: true
    },

    selectedChildId: {
      type: Number,
      default: null
    },

    metriche: {
      type: Object,
      default: () => ({})
    },

    distribuzione: {
      type: Object,
      default: () => ({})
    },
    dipendenti: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
   
    isPadre() {
      return (
        this.piano &&
        Array.isArray(this.piano.children) &&
        this.piano.children.length > 0
      );
    },

    isFiglio() {
      return !!(this.piano && this.piano.parent);
    },
    visibleChildren() {

      if (!this.piano) {
        return [];
      }

      return Array.isArray(this.piano.children)
        ? this.piano.children
        : [];
    },

    percentualeSpesa() {
      if (!this.piano || !this.piano.caricato) {
        return 0;
      }

      return (this.piano.speso / this.piano.caricato) * 100;
    },

    percentualeSpesaLabel() {
      return this.percentualeSpesa.toLocaleString("it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

  },

  methods: {
  
    toggleChild(child, event) {
      if (event && event.currentTarget) {
        event.currentTarget.blur();
      }

      this.$emit("select-child", child);
      
    },
    // Formatta l'importo in euro con separatore delle migliaia e due decimali
    formatEuro(value) {
      const numero = Number(value);

      if (isNaN(numero)) {
        return "€ 0,00";
      }

      const importo = new Intl.NumberFormat(
        "it-IT",
        {
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(numero);

      return `€ ${importo}`;
    }
  }
};
</script>

<style scoped>

.pic-dettaglio {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* HEADER */

.detail-box {
  background: #f4f6f9;
  color: #373F66;
  border: 2px solid #373F66;
  border-radius: 14px;
  padding: 16px;
}

.detail-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #373F66;
}

.detail-name {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 8px;
  color: #373F66;
}

.detail-dates {
  margin-top: 8px;
  margin-bottom: 14px;
  font-size: 12px;
  color: #373F66;
}

/* CHIP PADRE / FIGLIO */

.type-chip {
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 10px;
  margin-left: 8px;
  border-radius: 14px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .5px;
}

.type-chip.padre {
  background: #373F66;
  border: 1px solid #373F66;
  color: #fff;
}

.type-chip.figlio {
  background: #fff;
  border: 1px solid #373F66;
  color: #373F66;
}

/* PROGRESS BAR */

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #373F66;
}

.progress-value {
  color: #373F66;
}

.progress-bar-navy {
  background-color: #373F66 !important;
}

/* FIGLI */

.children-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.child-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #373F66;
  border-radius: 10px;
  color: #373F66;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  transition: all .2s;
}

.child-button:hover {
  background: #e9ecf2;
  border-color: #373F66;
  color: #373F66;
}

.child-button:focus,
.child-button:active,
.child-button:not(:disabled):not(.disabled):active {
  background: #e9ecf2;
  border-color: #373F66;
  color: #373F66;
  box-shadow: none;
}

/* KPI */

.kpi-grid {
  width: 100%;
}

.kpi-card {
  border: 0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
  height: 100%;
}

.kpi-card .card-body {
  padding: 10px 8px;
}

.kpi-label {
  font-size: 10px;
  color: #6c757d;
  margin-bottom: 4px;
  text-transform: uppercase;
  font-weight: 600;
}

.kpi-value {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.1;
}

.kpi-row {
  margin-left: -8px;
  margin-right: -8px;
}

.kpi-col {
  padding-left: 8px;
  padding-right: 8px;
}

/* COLORI KPI */

/* 1 - Totale Caricato
   stesso stile cromatico della card principale,
   ma con bordo uniforme */
.kpi-caricato {
  background: #f4f6f9;
  border: 2px solid #373F66;
}

.kpi-caricato .kpi-label {
  color: #373F66;
}

.kpi-caricato .kpi-value {
  color: #373F66;
}

/* Totale Speso */
.kpi-speso .kpi-value {
  color: #198754;
}

/* Residuo */
.kpi-residuo .kpi-value {
  color: #fd7e14;
}

/* Dipendenti */
.kpi-dipendenti .kpi-value {
  color: #373F66;
}

/* RESPONSIVE */

@media (max-width: 768px) {

  .detail-name {
    font-size: 18px;
  }

  .kpi-value {
    font-size: 20px;
  }

  .children-buttons {
    gap: 8px;
  }

  .child-button {
    width: 100%;
    justify-content: space-between;
  }

}

</style>